<template>
  <el-select
    v-on="$listeners"
    v-bind="{ ...$props }"
    v-model="value"
    filterable
    clearable
    :placeholder="placeholder"
  >
    <el-option
      v-for="item in options"
      :key="item.choiceKey"
      :disabled="item.state === 1"
      :label="item.value"
      :title="item.value"
      :value="item.choiceKey"
    >
      <!-- <slot name="select-label"></slot> -->
    </el-option>
  </el-select>
</template>

<script>
  import {singleChoiceProps} from '../index.js'

  export default {
    props: singleChoiceProps
  }
</script>

<style lang="scss" scoped></style>
